import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/AuthContext";
import { I18nProvider } from "@/i18n";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { FaqAssistant } from "@/components/FaqAssistant";
import Contact from "@/pages/Contact";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Craftsmen from "@/pages/Craftsmen";
import CraftsmanDetail from "@/pages/CraftsmanDetail";
import Jobs from "@/pages/Jobs";
import JobDetail from "@/pages/JobDetail";
import PostJob from "@/pages/PostJob";
import Dashboard from "@/pages/Dashboard";
import Messages from "@/pages/Messages";
import Admin from "@/pages/Admin";
import MapPage from "@/pages/Map";
import { PaymentSuccess, PaymentCancel } from "@/pages/Payment";
import Legal from "@/pages/Legal";
import { Imprint, Privacy } from "@/pages/LegalDoc";
import VerifyEmail from "@/pages/VerifyEmail";
import { ForgotPassword, ResetPassword } from "@/pages/PasswordReset";

function App() {
  return (
    <I18nProvider>
      <AuthProvider>
        <BrowserRouter>
          <div className="min-h-screen flex flex-col bg-[#FAF5F0]">
            <Header />
            <main className="flex-1">
              <Routes>
                <Route path="/" element={<Landing />} />
                <Route path="/login" element={<Login />} />
                <Route path="/register" element={<Register />} />
                <Route path="/verify-email" element={<VerifyEmail />} />
                <Route path="/forgot-password" element={<ForgotPassword />} />
                <Route path="/reset-password" element={<ResetPassword />} />
                <Route path="/craftsmen" element={<Craftsmen />} />
                <Route path="/craftsmen/:id" element={<CraftsmanDetail />} />
                <Route path="/jobs" element={<Jobs />} />
                <Route path="/jobs/:id" element={<JobDetail />} />
                <Route path="/post-job" element={<PostJob />} />
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/applications" element={<Dashboard view="offers" />} />
                <Route path="/profile" element={<Dashboard view="myprofile" />} />
                <Route path="/messages" element={<Messages />} />
                <Route path="/map" element={<MapPage />} />
                <Route path="/admin" element={<Admin />} />
                <Route path="/payment/success" element={<PaymentSuccess />} />
                <Route path="/payment/cancel" element={<PaymentCancel />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/legal" element={<Legal />} />
                <Route path="/impressum" element={<Imprint />} />
                <Route path="/privacy" element={<Privacy />} />
                <Route path="*" element={<Navigate to="/" replace />} />
              </Routes>
            </main>
            <Footer />
            <FaqAssistant />
          </div>
          <Toaster position="top-center" richColors />
        </BrowserRouter>
      </AuthProvider>
    </I18nProvider>
  );
}

export default App;
